export const LAYER_NAMES = {
	//CLUSTER POINTS
	POINT_LAYER: 'POINT_LAYER',
	HOVERED_POINTS: 'HOVERED_POINTS',
	HOVERED_POINTS_TEXT: 'HOVERED_POINTS_TEXT',
	//CLUSTERS
	CLUSTER_LAYER: 'CLUSTER_LAYER',
	HOVERED_CLUSTERS: 'HOVERED_CLUSTERS',
	CLUSTER_TEXT: 'CLUSTER_TEXT',
	//SEPARATED POINTS
	SEPARATED_POINTS_LAYER: 'SEPARATED_POINTS_LAYER',
	SEPARATED_HOVERED_POINTS: 'SEPARATED_HOVERED_POINTS',
	SEPARATED_HOVERED_POINTS_TEXT: 'SEPARATED_HOVERED_POINTS_TEXT',
};
